import React, { createContext, useContext, useState, ReactNode } from 'react';
import type { Message } from '@/pages/chat/types/chat';

interface ChatContextType {
    messages: Message[];
    setMessages: React.Dispatch<React.SetStateAction<Message[]>>;
    isTyping: boolean;
    setIsTyping: React.Dispatch<React.SetStateAction<boolean>>;
    addMessage: (message: Message) => void;
    clearMessages: () => void;
    createChat: () => Promise<any>;
}

const ChatContext = createContext<ChatContextType | undefined>(undefined);

export function ChatProvider({ children }: { children: ReactNode }) {
    const [messages, setMessages] = useState<Message[]>([]);
    const [isTyping, setIsTyping] = useState(false);

    const addMessage = (message: Message) => {
        setMessages(prev => [...prev, message]);
    };

    const clearMessages = () => {
        setMessages([]);
    };


    return (
        <ChatContext.Provider
            value={{
                messages,
                setMessages,
                isTyping,
                setIsTyping,
                addMessage,
                clearMessages,

            }}
        >
            {children}
        </ChatContext.Provider>
    );
}

export function useChatContext() {
    const context = useContext(ChatContext);
    if (context === undefined) {
        throw new Error('useChatContext must be used within a ChatProvider');
    }
    return context;
}
